import { Globals } from "../CoreApp/Globals";
import { UpdateHTMLSpinnerText } from "./UpdateHTMLSpinnerText";
import { appstr } from "./appstr";

export function updateWaitingExtraLongTime(message) {
  if (!Globals._wsMgr.fWaiting) return;
  Globals._wsMgr.fWaiting.timeoutmsg = UpdateHTMLSpinnerText(appstr("Please wait"));
  if (!Globals._wsMgr.fWaiting.fCancelButton) Globals._wsMgr.fWaiting.AddCancel();
}
